module.exports = __webpack_public_path__ + "static/media/light-checkout.79e187b1.png";